import type { CountryCode } from "@skv/core";

import groupAu from "@skv/assets/gfx/group-au.png";
import groupNz from "@skv/assets/gfx/group-nz.png";

interface HeroBannerProps {
  country: CountryCode;
}

export const HeroBanner = (props: HeroBannerProps) => {
  return (
    <>
      <section
        className="rounded-lg my-5"
        css={`
          background-color: #051a49;
          padding: 1.5rem;

          @media (min-width: 768px) {
            padding: 1.5rem 3.5rem;
          }
        `}
      >
        <div className="row">
          <div className="col-md d-flex align-items-center position-relative overflow-visible z-index-1 mb-4 mb-md-0">
            <h1
              className="mb-0"
              css={`
                color: #fff;

                @media (min-width: 768px) {
                  margin-right: -25%;
                }
              `}
            >
              <span
                className="d-block"
                css={`
                  color: #d48ef1;
                `}
              >
                Supporting
                <br />
                and connecting
              </span>
              communities in
              <br />
              {props.country === "au" ? "Australia" : "Aotearoa New Zealand"}
            </h1>
          </div>
          <div className="col-md d-flex justify-content-center align-items-center">
            <img
              src={props.country === "au" ? groupAu : groupNz}
              alt=""
              className="img-fluid"
              width={400}
              height={220}
            />
          </div>
        </div>
      </section>
    </>
  );
};
